<!--
     <CentroManagers
       :centros="centros"
     />
-->

<template>
  <div class="ca-layout">
    <div class="ca-sub-header">
      <v-autocomplete
        style="flex-grow: 4"
        v-model="select_centro"
        :items="centro_list"
        dense filled outlined clearable color="primary"
        label="Centro a gestionar"
      />

      <v-text-field
        v-model="filter_user"
        dense filled outlined clearable color="primary"
        label="Buscar usuarios"
      />
    </div>

    <div
      class="ca-loading-cont"
      v-if="loading"
    >
      <div></div>
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
      <h2>Consultando datos...</h2>
    </div>

    <div v-else-if="show_welcome" class="ca-welcome">
      <v-icon size="160px" color="primary">mdi-arrow-up-left</v-icon>
      <h2>Selecciona un centro para gestionarlo</h2>
    </div>

    <div v-else class="ca-matrixcont">

      <v-simple-table style="max-width: 700px">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Manager
              </th>
              <th class="text-left">
                Nombre de usuario
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="us in user_list"
              :key="us.id+'-'+us.manager"
              class="cacm"
            >
              <td>
                <div v-if="loading_users.indexOf(us.id) < 0">
                  <v-checkbox
                    class="cacm-checkbox"
                    :input-value="us.manager"
                    @change="toggle_manager(us)"
                  ></v-checkbox>
                </div>
                <div v-else>
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
              </td>

              <td>
                {{ us.name }}
              </td>

            </tr>
          </tbody>
        </template>
      </v-simple-table>

    </div>
  </div>
</template>


<style lang="scss">
 @import "@/sass/centroadmin.scss";

 tr.cacm {
   max-height: 32px;
 }

 .cacm-checkbox {
   height: 32px;
   margin: 0;
 }
</style>


<script>
 import { mapGetters } from 'vuex';
 import QCentro from '@/api/QCentro';

 function sleep(ms) {
   return new Promise(resolve => setTimeout(resolve, ms));
 }

 export default {
   name: 'CentrManager',

   components: {},

   props: {
     centros: {required: true},
   },

   data: () => ({
     select_centro: null,
     filter_user: '',
     loading: false,
     raw_user_list: [],
     loading_users: [],
   }),

   computed: {
     ...mapGetters(['site_id']),

     show_welcome() {
       return !this.select_centro;
     },

     user_list() {
       const search = (this.filter_user || '').toLowerCase();
       let list = this.raw_user_list;

       if (search) {
         list = list.filter(us => us.name.toLowerCase().indexOf(search) >= 0);
       }

       list.sort(function(a, b) {
         if (a.manager && !b.manager) {
           return -1;
         } else if (!a.manager && b.manager) {
           return +1;
         }
         return a.name.localeCompare(b.name);
       });

       return list;
     },

     centro_list() {
       return (Object.values(this.centros) || []).map(c => ({
         value: c.id,
         text: c.path_str,
       }));
     },
   },

   methods: {
     async get_user_manager_list(centro_id) {
       const users = await QCentro.list_manager_candidates(this.site_id, centro_id);
       this.raw_user_list = Object.values(users).map(us => ({
         id: us.id,
         name: us.name,
         manager: !!us.manager,
       }));
     },

     async toggle_manager(us) {
       this.loading_users.push(us.id);

       const centro = this.select_centro;
       const response = await QCentro.set_user_manager(this.site_id, centro, us.id, !us.manager);
       await this.get_user_manager_list(centro);

       const pos = this.loading_users.indexOf(us.id);
       if (pos >= 0) {
         this.loading_users.splice(pos, 1);
       }
     },
   },

   watch: {
     async select_centro(new_centro) {
       if (new_centro) {
         this.loading = true;
         await this.get_user_manager_list(new_centro);
         this.loading = false;
       }
     },
   }
 }
</script>
